import styled from "styled-components";
import { Button } from "@mui/material";

/** Estilos compartilhados pelos modais de cadastro rápido (Paciente, Médico,
 * Instrumentador, Hospital, Tipo de Cirurgia) acionados a partir de
 * "Nova Cirurgia" — antes duplicados byte-a-byte em cada styles.ts. */

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const InputGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  color: ${({ theme }) => theme.colors.text};

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

/** Campo que deve ocupar as duas colunas do grid (ex: textarea de Observação). */
export const FullWidth = styled.div`
  grid-column: 1 / -1;
`;

export const SubmitButton = styled(Button).attrs(({ theme }) => ({
  style: {
    color: "white",
  },
}))`
  width: 100%;
  padding: 12px;
  font-weight: 700;
  font-size: 15px;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.28);

  &:hover {
    box-shadow: 0 6px 18px rgba(37, 99, 235, 0.36);
  }
`;
